import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { UpdateMission } from '../../../store/actions/mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { PortabilityDatesService } from '../../../services/portability-dates.service';

@Component({
  selector: 'app-egelirr-ko',
  templateUrl: './egelirr-ko.component.html',
  styleUrls: ['./egelirr-ko.component.css'],
  standalone: false
})
export class EgelirrKoComponent implements OnInit {

  @Input()
  selectedLine: LineInterface;

  dates: Array<string>;
  formEgelirr: FormGroup;
  formSubmitted: boolean;
  invalidRio: boolean;
  environment = environment;
  errors: any = {
    rio: {
      required: `Ce champ est obligatoire.`,
    },
    portabilityDate: {
      required: `Ce champ est obligatoire.`,
    }
  };

  constructor(
      private store: Store<any>,
      private formBuilder: FormBuilder,
      private portabilityDatesService: PortabilityDatesService,
  ) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.invalidRio = false;
    this.portabilityDatesService.get().subscribe(dates => {
      this.dates = dates;
      this.initForm();
    });
  }

  initForm() {
    this.formSubmitted = false;
    this.formEgelirr = this.formBuilder.group({});
    this.formEgelirr.addControl('portabilityDate', this.formBuilder.control('', [Validators.required]));
    this.formEgelirr.addControl('rio', this.formBuilder.control('', [Validators.required]));
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    this.formSubmitted = true;
    this.invalidRio = false;
    if (this.formEgelirr.valid) {
      if (this.isValidRio()) {
        this.formSubmitted = false;
        const splitDate = this.formEgelirr.get('portabilityDate').value.split('/');
        const data = {
          phoneNumber: this.selectedLine.phoneNumber,
          rio: this.formEgelirr.get('rio').value,
          portabilityDate: splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
        };
        this.store.dispatch(new UpdateMission(data, ConstsHelper.PROCEDURE_EGELIRR_KO));
      } else {
        this.invalidRio = true;
      }
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.formEgelirr.controls[formControlName].invalid) {
      Object.keys(this.formEgelirr.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  private isValidRio() {
    const rio = this.formEgelirr.get('rio').value.toUpperCase();
    const op = rio.substring(0, 2);
    const contractType = rio.substring(2, 3);
    // Op is CORIOLIS, we can't accept it for now
    if (environment.data.brand === 'coriolis' && op === '10') {
      return false;
    }

    // Op is BLU / Prixtel, we can't accept them for now
    if (environment.data.brand === 'prixtel' && ((op === '45' || op === '69') && contractType.toString() !== 'P' && contractType.toString() !== 'E')) {
      return false;
    }
    const order = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+';
    const res = [0, 0, 0];
    const tmp: string = rio.substring(0, 9) + this.selectedLine.phoneNumber;
    for (let i = 0; i < tmp.length; i++) {
      const position: number = order.indexOf(tmp.charAt(i));
      res[0] = (res[0] + position) % 37;
      res[1] = (2 * res[1] + position) % 37;
      res[2] = (4 * res[2] + position) % 37;
    }
    const key: string = order.charAt(res[0]) + order.charAt(res[1]) + order.charAt(res[2]);
    return !(rio.substring(9, rio.length) !== key);
  }
}
